// extracted by mini-css-extract-plugin
export default {"mainContainer":"navbarLogo_mainContainer__ocJEn","mainContainerSmall":"navbarLogo_mainContainerSmall__0rNVa"};